<Input
  id={{this.field.id}}
  @type="checkbox"
  @checked={{this.field.value}}
  tabindex={{this.field.tabindex}}
  class={{this.fieldClass}}
/>